export enum PaymentTypeFamily {
  Upfront,
  Refund,
  Duplicate,
  Payment
}

export enum PaymentTypeOption {
  UpfrontPayment = 'Upfront Payment',
  UpfrontRefund = 'Upfront Refund',
  ClaimRefund = 'Claim Refund',
  ManualPayment = 'Manual Payment',
  DuplicatePayment = 'Duplicate Payment',
  PaymentRun= 'Payment Run',
}
